import styled from 'styled-components'

// Styles from the approved mockup (EAuditor.App docs/dashboard/Home-Dashboard-Mockup-B.html), scoped to this page.
export const HomeDashboardContainer = styled.div`
    --hd-bg: #eef0f5;
    --hd-card: #ffffff;
    --hd-fg: #14181f;
    --hd-mut: #667085;
    --hd-line: #e1e5ee;
    --hd-primary: #1e44b8;
    --hd-primary-d: #182f96;
    --hd-primary-soft: #e8edfb;
    --hd-hero: #182f96;
    --hd-hero2: #2b4fd0;
    --hd-hero-mut: #c3cff7;
    --hd-ok: #17803f;
    --hd-ok-bg: #e6f5ec;
    --hd-warn: #a15c07;
    --hd-warn-bg: #fdf0dc;
    --hd-bad: #c42b2b;
    --hd-bad-bg: #fde8e8;
    --hd-info: #1e44b8;
    --hd-info-bg: #e8edfb;
    --hd-gray-btn: #e6e8ec;
    --hd-gray-btn-fg: #3a404c;
    --hd-heat-bad: #e35d5d;
    --hd-heat-warn: #f0b24d;
    --hd-heat-ok: #4cc17b;
    --hd-heat-great: #17803f;
    --hd-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 1px 3px rgba(16, 24, 40, 0.06);

    background: var(--hd-bg);
    color: var(--hd-fg);
    font-size: 14px;
    line-height: 1.45;
    margin: -14px;
    padding: 20px 24px 60px;
    min-height: 100%;

    button {
        font: inherit;
        cursor: pointer;
    }
    h1, h2, h3 {
        font-family: inherit;
    }
    .hd-btn {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        border: 0;
        border-radius: 9px;
        padding: 9px 14px;
        font-weight: 600;
        background: var(--hd-gray-btn);
        color: var(--hd-gray-btn-fg);
    }
    .hd-btn.p {
        background: var(--hd-primary);
        color: #fff;
    }
    .hd-btn.w {
        background: #fff;
        color: var(--hd-hero);
    }
    .hd-btn.g {
        background: rgba(255, 255, 255, 0.14);
        color: #fff;
    }
    .hd-btn.sm {
        padding: 6px 10px;
        font-size: 12.5px;
        border-radius: 7px;
    }
    .hd-btn.o {
        background: transparent;
        border: 1px solid var(--hd-line);
        color: var(--hd-fg);
    }
    .hd-btn:disabled {
        opacity: 0.55;
        cursor: default;
    }
    .hd-link {
        background: transparent;
        border: 0;
        color: var(--hd-primary);
        font-weight: 600;
        padding: 0;
        font-size: 13px;
    }
    .seg {
        display: inline-flex;
        background: var(--hd-gray-btn);
        padding: 3px;
        border-radius: 9px;
        gap: 2px;
    }
    .seg button {
        border: 0;
        background: transparent;
        color: var(--hd-gray-btn-fg);
        padding: 5px 11px;
        border-radius: 7px;
        font-weight: 600;
        font-size: 12.5px;
    }
    .seg button[aria-pressed='true'] {
        background: var(--hd-card);
        color: var(--hd-fg);
        box-shadow: var(--hd-shadow);
    }
    .seg.onhero {
        background: rgba(255, 255, 255, 0.14);
    }
    .seg.onhero button {
        color: var(--hd-hero-mut);
    }
    .seg.onhero button[aria-pressed='true'] {
        background: #fff;
        color: var(--hd-hero);
    }
    .pill {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        border-radius: 999px;
        padding: 2px 9px;
        font-size: 11.5px;
        font-weight: 700;
        white-space: nowrap;
    }
    .pill.ok { background: var(--hd-ok-bg); color: var(--hd-ok); }
    .pill.warn { background: var(--hd-warn-bg); color: var(--hd-warn); }
    .pill.bad { background: var(--hd-bad-bg); color: var(--hd-bad); }
    .pill.info { background: var(--hd-info-bg); color: var(--hd-info); }
    .pill.gray { background: var(--hd-gray-btn); color: var(--hd-gray-btn-fg); }
    .score {
        font-weight: 700;
        font-variant-numeric: tabular-nums;
    }
    .score.ok { color: var(--hd-ok); }
    .score.warn { color: var(--hd-warn); }
    .score.bad { color: var(--hd-bad); }

    /* hero band */
    .hero,
    .next {
        background: linear-gradient(110deg, var(--hd-hero), var(--hd-hero2));
        color: #fff;
        border-radius: 16px;
        box-shadow: var(--hd-shadow);
    }
    .hero {
        padding: 20px 26px 22px;
        display: flex;
        flex-direction: column;
        gap: 18px;
    }
    .hero .greet {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;
    }
    .hero h1,
    .next h1 {
        margin: 0;
        font-size: 22px;
        font-weight: 800;
        letter-spacing: -0.01em;
        color: #fff;
    }
    .hero .sub,
    .next .sub {
        color: var(--hd-hero-mut);
        margin-top: 3px;
        font-size: 13px;
    }
    .hero .ctl {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        align-items: center;
    }
    .hero select {
        font: inherit;
        font-size: 12.5px;
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 8px;
        padding: 5px 9px;
        background: rgba(255, 255, 255, 0.12);
        color: #fff;
        max-width: 220px;
    }
    .hero select option {
        color: #14181f;
    }
    .hero .main {
        display: flex;
        align-items: center;
        gap: 30px;
        flex-wrap: wrap;
    }
    .gauge {
        display: flex;
        align-items: center;
        gap: 18px;
        flex: 0 0 auto;
    }
    .gauge .big {
        font-size: 44px;
        font-weight: 800;
        letter-spacing: -0.03em;
        line-height: 1;
        white-space: nowrap;
    }
    .gauge .big small {
        font-size: 18px;
        font-weight: 600;
        color: var(--hd-hero-mut);
        margin-left: 4px;
    }
    .gauge .lbl {
        color: var(--hd-hero-mut);
        font-size: 12.5px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        white-space: nowrap;
    }
    .gauge .delta {
        font-size: 13px;
        margin-top: 4px;
        color: #b9f0cc;
        font-weight: 600;
    }
    .gauge .delta.bad {
        color: #ffb4b4;
    }
    .stats {
        display: flex;
        flex-wrap: wrap;
        row-gap: 10px;
    }
    .stats > button {
        background: transparent;
        border: 0;
        color: inherit;
        text-align: left;
        padding: 4px 22px;
        border-left: 1px solid rgba(255, 255, 255, 0.2);
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
    .stats > button:first-child {
        border-left: 0;
    }
    .stats > button:hover {
        background: rgba(255, 255, 255, 0.08);
    }
    .stats .v {
        font-size: 26px;
        font-weight: 800;
        letter-spacing: -0.02em;
        line-height: 1.1;
        white-space: nowrap;
    }
    .stats .v small {
        font-size: 13px;
        color: var(--hd-hero-mut);
        font-weight: 600;
        margin-left: 3px;
    }
    .stats .l {
        font-size: 12px;
        color: var(--hd-hero-mut);
        font-weight: 600;
        white-space: nowrap;
    }
    .stats .x {
        font-size: 12px;
        color: #ffd9a8;
    }
    .stats .x.bad { color: #ffb4b4; }
    .stats .x.ok { color: #b9f0cc; }
    .modechip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: rgba(255, 255, 255, 0.14);
        border-radius: 999px;
        padding: 3px 10px;
        font-size: 11.5px;
        font-weight: 600;
        color: #fff;
        margin-top: 8px;
    }

    /* profile strip */
    .profile {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        margin: 12px 0 0;
        padding: 9px 14px;
        border: 1px dashed var(--hd-line);
        border-radius: 12px;
        background: var(--hd-card);
        color: var(--hd-mut);
        font-size: 12.5px;
    }
    .profile b {
        color: var(--hd-fg);
    }
    .profile .hd-link {
        margin-left: auto;
        font-size: 12.5px;
    }
    .notice {
        margin-top: 12px;
        padding: 10px 14px;
        border-radius: 12px;
        background: var(--hd-info-bg);
        color: var(--hd-info);
        font-size: 13px;
    }
    .notice.bad {
        background: var(--hd-bad-bg);
        color: var(--hd-bad);
    }

    /* body grid */
    .body {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 380px;
        gap: 18px;
        margin-top: 18px;
        align-items: start;
    }
    .body.single {
        grid-template-columns: minmax(0, 1fr);
    }
    .body.halves {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
    .col {
        display: flex;
        flex-direction: column;
        gap: 18px;
        min-width: 0;
    }
    .card {
        background: var(--hd-card);
        border: 1px solid var(--hd-line);
        border-radius: 14px;
        box-shadow: var(--hd-shadow);
        min-width: 0;
    }
    .card-h {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 16px 0;
        gap: 8px;
    }
    .card-h h3 {
        margin: 0;
        font-size: 14.5px;
        font-weight: 700;
    }
    .card-h .sub {
        color: var(--hd-mut);
        font-size: 12.5px;
        margin-top: 1px;
    }
    .card-b {
        padding: 12px 16px 16px;
        overflow-x: auto;
    }
    .empty {
        color: var(--hd-mut);
        font-size: 13px;
        padding: 6px 0;
    }
    .emptycard {
        display: flex;
        gap: 12px;
        align-items: flex-start;
        background: var(--hd-card);
        border: 1px dashed var(--hd-line);
        border-radius: 14px;
        padding: 16px;
        color: var(--hd-mut);
        font-size: 13px;
    }
    .emptycard b {
        color: var(--hd-fg);
    }

    /* heatmap */
    .heat {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 8px;
    }
    .heat button {
        border: 0;
        border-radius: 10px;
        padding: 12px 12px 10px;
        text-align: left;
        color: #fff;
        display: flex;
        flex-direction: column;
        gap: 3px;
        min-height: 92px;
    }
    .heat button:hover {
        filter: brightness(1.08);
    }
    .heat .n {
        font-weight: 600;
        font-size: 12.5px;
        line-height: 1.25;
        opacity: 0.95;
        overflow-wrap: anywhere;
    }
    .heat .s {
        font-size: 24px;
        font-weight: 800;
        letter-spacing: -0.02em;
        margin-top: auto;
    }
    .heat .s small {
        font-size: 12px;
        font-weight: 600;
        opacity: 0.9;
        margin-left: 4px;
    }
    .heat .o {
        font-size: 11.5px;
        opacity: 0.9;
    }
    .legend {
        display: flex;
        gap: 14px;
        flex-wrap: wrap;
        font-size: 12px;
        color: var(--hd-mut);
        margin-top: 10px;
        align-items: center;
    }
    .legend i {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 3px;
        margin-right: 5px;
        vertical-align: -2px;
    }

    /* trend + mix */
    .two {
        display: grid;
        grid-template-columns: 3fr 2fr;
        gap: 18px;
    }
    .mix {
        display: flex;
        align-items: center;
        gap: 18px;
    }
    .mix ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 7px;
        font-size: 13px;
        flex: 1;
    }
    .mix li {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .mix li i {
        width: 10px;
        height: 10px;
        border-radius: 3px;
        display: inline-block;
    }
    .mix li b {
        margin-left: auto;
        font-variant-numeric: tabular-nums;
    }

    /* inbox */
    .inbox {
        position: sticky;
        top: 8px;
    }
    .inbox .grp {
        border-top: 1px solid var(--hd-line);
    }
    .inbox .grp:first-child {
        border-top: 0;
    }
    .inbox .gh {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 11px 16px 6px;
        font-weight: 700;
        font-size: 13px;
    }
    .inbox .gh .n {
        background: var(--hd-gray-btn);
        color: var(--hd-gray-btn-fg);
        border-radius: 999px;
        padding: 0 8px;
        font-size: 11.5px;
    }
    .inbox .gh .n.bad { background: var(--hd-bad-bg); color: var(--hd-bad); }
    .inbox .gh .n.warn { background: var(--hd-warn-bg); color: var(--hd-warn); }
    .inbox .gh .n.info { background: var(--hd-info-bg); color: var(--hd-info); }
    .inbox .gh .hd-link {
        margin-left: auto;
        font-size: 12px;
    }
    .inbox .it {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 10px;
        padding: 7px 16px 9px;
        align-items: center;
        border-left: 3px solid transparent;
    }
    .inbox .it:hover {
        background: var(--hd-bg);
    }
    .inbox .it.bad { border-left-color: var(--hd-bad); }
    .inbox .it.warn { border-left-color: var(--hd-warn); }
    .inbox .it.info { border-left-color: var(--hd-info); }
    .inbox .t {
        font-weight: 600;
        font-size: 13px;
        overflow-wrap: anywhere;
    }
    .inbox .s {
        color: var(--hd-mut);
        font-size: 12px;
        margin-top: 1px;
    }

    /* activity */
    .stream {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .stream li {
        display: grid;
        grid-template-columns: 54px 24px 1fr;
        gap: 8px;
        align-items: start;
        padding: 8px 0;
        border-top: 1px solid var(--hd-line);
        font-size: 13px;
    }
    .stream li:first-child {
        border-top: 0;
    }
    .stream time {
        color: var(--hd-mut);
        font-variant-numeric: tabular-nums;
    }
    .stream .s {
        color: var(--hd-mut);
        font-size: 12px;
    }
    .stream button.hd-link {
        text-align: left;
        color: var(--hd-fg);
        font-weight: 400;
    }
    .d {
        width: 22px;
        height: 22px;
        border-radius: 6px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .d.ok { background: var(--hd-ok-bg); color: var(--hd-ok); }
    .d.bad { background: var(--hd-bad-bg); color: var(--hd-bad); }
    .d.warn { background: var(--hd-warn-bg); color: var(--hd-warn); }
    .d.info { background: var(--hd-info-bg); color: var(--hd-info); }

    /* auditor view */
    .next {
        padding: 22px 26px;
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 20px;
        align-items: center;
    }
    .next .eyebrow {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--hd-hero-mut);
    }
    .next h1 {
        margin: 4px 0 2px;
        font-size: 24px;
    }
    .next .bar {
        height: 6px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        margin-top: 12px;
        max-width: 360px;
    }
    .next .bar i {
        display: block;
        height: 100%;
        background: #fff;
        border-radius: 4px;
    }
    .next .acts {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: flex-end;
    }
    .dayhead {
        margin: 16px 0 6px;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
    }
    .dayhead h3 {
        margin: 0;
        font-size: 14.5px;
    }
    .strip {
        display: flex;
        gap: 10px;
        overflow-x: auto;
        padding: 4px 2px 8px;
    }
    .strip .chip {
        flex: 0 0 212px;
        background: var(--hd-card);
        border: 1px solid var(--hd-line);
        border-left: 4px solid var(--chip-color, var(--hd-line));
        border-radius: 12px;
        padding: 12px 14px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        box-shadow: var(--hd-shadow);
        text-align: left;
        color: var(--hd-fg);
        position: relative;
    }
    .strip .chip time {
        font-weight: 700;
        font-size: 14px;
        color: var(--hd-mut);
    }
    .strip .chip.done time { color: var(--hd-ok); }
    .strip .chip.late time { color: var(--hd-bad); }
    .strip .chip .t {
        font-weight: 600;
        font-size: 13px;
        padding-right: 54px;
        overflow-wrap: anywhere;
    }
    .strip .chip .s {
        color: var(--hd-mut);
        font-size: 12px;
    }
    .strip .chip .st {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .kstrip {
        display: grid;
        grid-template-columns: repeat(var(--k, 4), 1fr);
        background: var(--hd-card);
        border: 1px solid var(--hd-line);
        border-radius: 14px;
        box-shadow: var(--hd-shadow);
        margin-top: 12px;
    }
    .kstrip > div {
        border-left: 1px solid var(--hd-line);
        padding: 14px 16px;
        display: flex;
        flex-direction: column;
        gap: 3px;
    }
    .kstrip > div:first-child {
        border-left: 0;
    }
    .kstrip .l {
        font-size: 12px;
        color: var(--hd-mut);
        font-weight: 600;
    }
    .kstrip .v {
        font-size: 26px;
        font-weight: 800;
        letter-spacing: -0.02em;
        line-height: 1.1;
    }
    .kstrip .v small {
        font-size: 13px;
        color: var(--hd-mut);
        margin-left: 3px;
    }
    .kstrip .x {
        font-size: 12px;
        color: var(--hd-mut);
    }
    .kstrip .x.ok { color: var(--hd-ok); }
    .kstrip .x.bad { color: var(--hd-bad); }
    .kstrip .x.warn { color: var(--hd-warn); }
    .tbl {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
    }
    .tbl th {
        text-align: left;
        color: var(--hd-mut);
        font-weight: 600;
        font-size: 12px;
        padding: 6px 8px;
        border-bottom: 1px solid var(--hd-line);
    }
    .tbl td {
        padding: 9px 8px;
        border-bottom: 1px solid var(--hd-line);
        vertical-align: middle;
    }
    .tbl tr:last-child td {
        border-bottom: 0;
    }
    .tbl .num {
        text-align: right;
        font-variant-numeric: tabular-nums;
    }
    .tbl .sub {
        color: var(--hd-mut);
        font-size: 12px;
    }

    @media (max-width: 1300px) {
        .body,
        .body.halves {
            grid-template-columns: minmax(0, 1fr);
        }
        .inbox {
            position: static;
        }
        .heat {
            grid-template-columns: repeat(4, 1fr);
        }
    }
    @media (max-width: 900px) {
        margin: -14px -14px;
        padding: 14px 12px 40px;
        .two {
            grid-template-columns: 1fr;
        }
        .stats > button {
            border-left: 0;
            padding: 6px 14px 6px 0;
        }
        .heat {
            grid-template-columns: repeat(2, 1fr);
        }
        .next {
            grid-template-columns: 1fr;
        }
        .next .acts {
            justify-content: flex-start;
        }
        .kstrip {
            grid-template-columns: 1fr 1fr;
        }
        .kstrip > div:nth-child(odd) {
            border-left: 0;
        }
    }
`
